var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVrArCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 2.66602H6.3335L4.66683 4.66602H2.66683C2.31321 4.66602 1.97407 4.80649 1.72402 5.05654C1.47397 5.30659 1.3335 5.64573 1.3335 5.99935V11.9993C1.3335 12.353 1.47397 12.6921 1.72402 12.9422C1.97407 13.1922 2.31321 13.3327 2.66683 13.3327H13.3335C13.6871 13.3327 14.0263 13.1922 14.2763 12.9422C14.5264 12.6921 14.6668 12.353 14.6668 11.9993V5.99935C14.6668 5.64573 14.5264 5.30659 14.2763 5.05654C14.0263 4.80649 13.6871 4.66602 13.3335 4.66602H11.3335L9.66683 2.66602Z",
    stroke: "#EE2B2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.666C9.10457 10.666 10 9.77059 10 8.66602C10 7.56145 9.10457 6.66602 8 6.66602C6.89543 6.66602 6 7.56145 6 8.66602C6 9.77059 6.89543 10.666 8 10.666Z",
    stroke: "#EE2B2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrArCamera);
export default __webpack_public_path__ + "static/media/vr-ar-camera.4fe0784bf6b5367bbe9e07ccba3b5b0a.svg";
export { ForwardRef as ReactComponent };